import { SortOrder } from "@/components/ui/table-final-saviour/Table/TableHeaderCell/TableHeaderCellSortable/table-header-cell-sortable.types";

export const sortIconMap: Record<SortOrder, string> = {
    asc: "caret-up",
    desc: "caret-down",
    none: "sort",
};
